<button mat-stroked-button 
    [disabled]="disabled" (click)="clickButton()"
    *ngIf="asButton"
    title="{{'attach / detach' | translate:['tmc-yard.widgets.sac-client.station-transport-details.action.call', translationService.language]}}">
    <sc-icon iconClass="fa-envelope-square"></sc-icon>
</button>
<button mat-icon-button 
    [disabled]="disabled" (click)="clickButton()"
    *ngIf="!asButton"
    title="{{'attach / detach' | translate:['tmc-yard.widgets.sac-client.station-transport-details.action.call', translationService.language]}}">
    <sc-icon iconClass="fa-envelope-square"></sc-icon>
</button>